export type PointInfo = {
  longitude?: number;
  latitude?: number;
  altitude?: number;
};

export enum InfoToolEvent {
  LeftClick = 'leftClick',
}
